/**
 * Created by cd01 on 2017/8/22.
 */
{
    angular.module('interfaceModule')
        .controller('proclamationController',proclamationController);
    proclamationController.$inject = ['$scope',"$state",'$http','$stateParams','utils.constant','alertControl','utils.platform','$timeout','utils.common','requestHandler','ModalWindow','utils.currentUser','request.order','$sce'];
    function proclamationController($scope,$state,$http,$stateParams,constant,alertControl,platform,$timeout,common,requestHandler,ModalWindow,currentUser,orderRequest,$sce) {
        let vm = this;
        let collect = {
            'activate': activate,
            'getList': getList,
            'isDetail': false,//是否显示公告详情
            "getDetail": getDetail, //获取公告详情函数
            "backList": backList,//返回公告列表
            "announcement": [], //公告信息
            "announcementDetail": [],//公告详情
            "bulletinShow": true,
            "videoShow": true,
            "getVideo": getVideo,   //点击获取视频
            "isVideo": false,
            "videoFile": {},
            "gapShow": true,
            'isMobile': null,
            "videoUrlFun": videoUrlFun,
            "getVideoList": getVideoList,
            "videoList":[],
            "haveBullect": true,
            "haveGap": true,
            "haveVideos": true,
        };
        vm.collect = collect;
        activate();

        function activate() {
            //console.log($stateParams);
            collect.isMobile = platform.isIOS() || platform.isAndroid();

        }

        function getList() {
            let _data = [{
                'operationtype': '4',//操作类型 1 添加公告 2修改公告 3删除公告 4查询公告
                'querytype': '1', //查询类型 1查询全部公告简略 2全部详细 3指定详细
            }];
            let params = "announcement=" + JSON.stringify(_data);
            console.log("传递公告参数" + params);
            requestHandler.simpleRequest(constant.action.announcement, params,
                function (responce) {
                    console.log(responce);
                    if (responce.data[0].result == 1) {
                        collect.announcement = responce.data[0].announcement;
                    } else if (responce.data[0].result == 0) {
                        console.log("公告列表获取不成功");
                        collect.haveBullect = false;
                        collect.haveGap = false;
                    }
                })
        }

        function getVideoList(){
            let _data =[{
                "operationtype" : 1
            }];
            let params = "videooperate=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.videoOperate, params,
                function(responce){
                    console.log('视频信息',responce);
                    if (responce.data[0].result == 1){
                        collect.videoList = responce.data[0].videosInfo.rows;

                    }else if(responce.data[0].result == 0){
                        collect.haveVideos = false;
                        collect.haveGap = false;
                    }
                })
        }


        getList();
        getVideoList();
        $(".con_div").html($(".con_text").html());
        function getDetail(id) {
            collect.isDetail = true;
            collect.videoShow = false;
            collect.gapShow = false;
            console.log("选中的公告id:" + id);
            let _data = [{
                'announcementid': id,
                'operationtype': '4',//操作类型 1 添加公告 2修改公告 3删除公告 4查询公告
                'querytype': '3', //查询类型 1查询全部公告简略 2全部详细 3指定详细
            }]
            let params = "announcement=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.announcement, params,
                function (responce) {
                    console.log(responce);
                    if (responce.data[0].result == 1) {
                        collect.announcementDetail = responce.data[0].announcement;

                    } else if (responce.data[0].result == 0) {
                        console.log("详情显示不成功")
                    }
                })
        }

        function backList(num) {
            if (num == 1) {
                collect.isDetail = false;
                collect.videoShow = true;
                collect.gapShow = true;
            } else if (num == 2) {
                collect.isVideo = false;
                collect.bulletinShow = true;
                collect.gapShow = true;
            }

        }

        function getVideo(item) {
            collect.bulletinShow = false;
            collect.isVideo = true;
            collect.gapShow = false;

            console.log('所选视频',item);
            // let videos = {
            //     video1: {
            //         "title": "苹果注册视频1苹果注册视频1苹果注册视频1",
            //         "videoName": "xiadan.mp4",
            //         "videoUrl": ''
            //     },
            //     video2: {
            //         "title": "下单视频1",
            //         "videoName": "3theB.mp4",
            //         "videoUrl": ''
            //     }
            // };
            // switch (num) {
            //     case 1:
            //         collect.videoFile = videos.video1;
            //         break;
            //     case 2:
            //         collect.videoFile = videos.video2;
            // }
            // var url_1 = "video/" + collect.videoFile.videoName;
            // collect.videoFile.videoUrl = videoUrlFun(url_1);
            // console.log('转换后路径',collect.videos.videoUrl);
            // console.log('获取的视频信息：', collect.videoFile);
            collect.videoFile.title = item.title;
            collect.videoFile.content = item.content;
            collect.videoFile.editor = item.editor;
            collect.videoFile.edittime = item.edittime;
            var path_url = "video/" + item.videoname;
            collect.videoFile.videoUrl = videoUrlFun(path_url);

        };

        //视频路径angular 模式转化
        function videoUrlFun(url){
            console.log(url);
            console.log("视频路径angular 模式转化");
            let urlFun = $sce.trustAsResourceUrl(url);
            console.log('转换后路径',urlFun);
            return urlFun ;

        }
    }

}